import { headers } from '@/_services/headers'
import { encrypt, decrypt } from '../../_services/encryption';
const state = {
    userBudget: [],
    systemCategories: [],
    myCategories: [],
};
const mutations = {
    // set user budget
    SET_USER_BUDGET(state, payload) {
        state.userBudget = payload;
    },
    // set system categories
    SET_SYSTEM_CATEGORIES(state, payload) {
        state.systemCategories = payload;
    },
    // set my categories
    SET_MY_CATEGORIES(state, payload) {
        state.myCategories = payload;
    }
};
const actions = {
    // get user budget
    async getUserBudget({ commit }, { data }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Budget/MyBudget/${data.accountNumber}/${data.period}`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_USER_BUDGET', userParseData);
            }
            return response;
        }
    },
    // get system categories
    async getSystemCategories({ commit }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Budget/SystemCategories`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_SYSTEM_CATEGORIES', userParseData);
            }
            return response;
        }
    },
    // delete budget
    async deleteBudget({}, payload ) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.put(`/Budget/delete/${payload}`, encryptedData, { headers });
            return response;
        }
    },
    // create budget
    async createBudget({}, payload) {
        const encryptedData = encrypt(payload);
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.post(`/Budget/Create`, encryptedData, { headers });
            return response;
        }
    },
    // update budget
    async updateBudget({}, { payload, id }) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.put(`/Budget/Update/${id}`, payload, { headers });
            return response;
        }
    },
    // my categories
    async myCategories({ commit }, data) {
        const accessToken = localStorage.getItem('accessToken');
        if (accessToken) {
            headers.Authorization = 'Bearer ' + accessToken;
            const response = await this._vm.$http.get(`/Budget/MyCategories?accountNumber=${data}`, { headers });
            const decryptedData = decrypt(response.data);
            const userParseData = JSON.parse(decryptedData);
            if (response.status === 200) {
                commit('SET_MY_CATEGORIES', userParseData);
            }
            return response;
        }
    },
};
const getters = {
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};